import { AppShell } from "@mantine/core";

import type { PropsWithChildren } from "react";

export const LayoutPromo = ({ children }: PropsWithChildren) => {
  return (
    <AppShell
      withBorder={false}
      footer={{
        height: "auto",
        offset: false,
      }}
      padding={{
        base: "xs",
        sm: "lg",
      }}
      layout="alt"
    >
      <AppShell.Main p={16}>{children}</AppShell.Main>
    </AppShell>
  );
};

export default LayoutPromo;
